import { render, staticRenderFns } from "./AufgabenBoard.vue?vue&type=template&id=bf68f4c0&scoped=true"
import script from "./AufgabenBoard.vue?vue&type=script&lang=ts"
export * from "./AufgabenBoard.vue?vue&type=script&lang=ts"
import style0 from "./AufgabenBoard.vue?vue&type=style&index=0&id=bf68f4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf68f4c0",
  null
  
)

export default component.exports